<template>
  <div class='result-bg'>
    <div class='result'>
      <div class='result-title'>
        <span class='title-icon'>
          <v-icon>check_circle</v-icon>
        </span>
        <p class='title1'>试用申请成功</p>
        <p class='title2'>公司人员会尽快联系您，请耐心等待。</p>
      </div>
      <div class='result-content'>
        <p class='name'>{{ name }}，谢谢您！</p>
        <p class='desc'>
          感谢您对 BitXMesh 可信数据网格的关注，我们致力于破解数据孤岛、数据确权、数据隐私等难题，
          为企业提供可信的数据存储以及可控的数据共享环境，促进产业互联网和数字经济领域的协同创新。
        </p>
        <p>
          <router-link to='/'>
            <button class='home-btn'>回到首页</button>
          </router-link>
<!--          <button class='share-platform-btn'>-->
<!--            <a style="text-decoration: none;" target="_blank" href="http://dmall.bitxmesh.com:8003">查看共享平台</a>-->
<!--          </button>-->
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      name: localStorage.getItem('name')
    }
  }
}
</script>

<style lang="scss" scoped>
.result-bg {
  margin-top: 100px;
  margin-bottom: 60px;
  background: #fafafa;
  padding-top: 40px;
  padding-left: 156px;
  padding-right: 156px;
  .result {
    background: #fff;
    .result-title {
      background: #D1F2EB;
      height: 100px;
      padding-top: 26px;
      padding-left: 130px;
      .title1 {
        margin-bottom: 0;
        font-size: 16px;
        font-weight: normal;
        color: #343434;
      }
      .title2 {
        font-size: 14px;
        color: #80908c;
        margin-top: 10px;
      }
      .title-icon {
        position: absolute;
        margin-left: -60px;
        i {
          color: #1ABC9C;
          font-size: 44px;
        }
      }
    }
  }
  .result-content {
    height: 250px;
    padding-left: 70px;
    padding-top: 30px;
    .name {
      font-size: 24px;
      color: #343434;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .desc {
      font-size: 16px;
    }
    .home-btn {
      margin-right: 20px;
      background: rgba(29,181,244,1);
      width: 144px;
      height: 40px;
      color: #fff;
      border-radius: 2px;
      font-size: 16px;
    }
    .share-platform-btn {
      width:144px;
      height:40px;
      background:rgba(255,255,255,1);
      border-radius:2px;
      border:1px solid rgba(29,181,244,1);
      color: #1DB5F4;
      font-size: 16px;
    }
  }
}
</style>
